export default "__VITE_ASSET__D8iJJAJ2__"